import {
  useFileManagerStore,
  type FileManagerSortOrder,
} from "@/state/fileManagerStore";

const OPTIONS: { value: FileManagerSortOrder; label: string }[] = [
  { value: "uploaded", label: "Envio" },
  { value: "name", label: "Alfabetica" },
];

export function SortOrderSelect() {
  const sortOrder = useFileManagerStore((state) => state.sortOrder);
  const setSortOrder = useFileManagerStore((state) => state.setSortOrder);

  return (
    <label className="flex items-center gap-1.5 text-xs text-ink-300">
      Ordenar
      <select
        value={sortOrder}
        onChange={(event) => setSortOrder(event.target.value as FileManagerSortOrder)}
        className="rounded border border-ink-700 bg-ink-800 px-2 py-1 text-xs"
      >
        {OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
